import { NotificationCheckIcon } from '@tableau/icons/NotificationCheckIcon';
import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';

import { Node } from '../types/Node';
import { openAcceptClusterNodeDialog } from './AcceptClusterNodeConfirm';

export type AcceptClusterNodeButtonProps = Readonly<{
  node: Node;
  index: number;
  clusterId: string;
  disabled: boolean;
  refreshBaasEdgePools: () => void;
}>;

export function AcceptClusterNodeButton(props: AcceptClusterNodeButtonProps) {
  return <>
    {renderAcceptClusterNodeButton(props)}
  </>;
}


function renderAcceptClusterNodeButton(props: AcceptClusterNodeButtonProps) {
  const acceptNodeAction = ()=>{
    openAcceptClusterNodeDialog(props);
  };

  return (
    <span className={'tb-data-grid-icon tb-padded-left-small' + buttonPaddingLeftClass} data-tb-test-id={'pool-edit-cell'}>
      <ButtonWidget
        testId={'accept-pool-node'} buttonType={ButtonType.Outline}
        onClick={acceptNodeAction}
        style={{marginRight: 10, paddingRight:5,  paddingLeft:5, borderColor: 'transparent'}}
      >
        <span className={inlineBlockClass}>
          <NotificationCheckIcon size={14} className={verticalAlignClass} alt={''} />
          <span className={textPaddingLeftClass}>
            {Messages.dataConnectSiteSettingsAcceptClusterNodeButton()}
          </span>
        </span>
      </ButtonWidget>
    </span>
  );
}

export const inlineBlockClass = style({
  display: 'inline-block',
});
export const verticalAlignClass = style({
  verticalAlign: 'middle'
});
export const textPaddingLeftClass = style({
  paddingLeft: 2
});

export const buttonPaddingLeftClass = style({
  paddingLeft: 10
});

